import React, { useEffect, useState } from 'react';
import { fetchArticles } from '../services/api'; // 确保路径正确
import ArticleCard from '../components/ArticleCard';
import '../styles/MediumHome.css';

interface Article {
    id: number;
    title: string;
    author: string;
    date: string;
    summary: string;
    coverImage?: string;
    cover_image?: string;
}

const HomePage: React.FC = () => {
    const [articles, setArticles] = useState<Article[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const getArticles = async () => {
            try {
                setLoading(true);
                setError(null);

                const data = await fetchArticles();
                setArticles(data);
            } catch (error: any) {
                setError(error.message || '获取文章失败，请刷新页面重试');
            } finally {
                setLoading(false);
            }
        };

        getArticles();
    }, []);

    if (loading) {
        return (
            <main style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: 'calc(100vh - 64px)', // 减去头部高度
                marginTop: '64px' // 头部高度
            }}>
                <div style={{
                    textAlign: 'center',
                    color: '#666',
                    fontSize: '16px'
                }}>
                    正在加载文章列表...
                </div>
            </main>
        );
    }

    if (error) {
        return (
            <main style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: 'calc(100vh - 64px)',
                marginTop: '64px'
            }}>
                <div style={{
                    textAlign: 'center',
                    color: '#c33',
                    fontSize: '16px'
                }}>
                    <div style={{ marginBottom: '20px' }}>😕 {error}</div>
                    <button
                        onClick={() => window.location.reload()}
                        style={{
                            padding: '10px 20px',
                            background: '#1a8917',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '14px'
                        }}
                    >
                        重新加载
                    </button>
                </div>
            </main>
        );
    }

    if (articles.length === 0) {
        return (
            <main style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: 'calc(100vh - 64px)',
                marginTop: '64px'
            }}>
                <div style={{
                    textAlign: 'center',
                    color: '#666',
                    fontSize: '16px'
                }}>
                    暂无文章，快去写一篇吧！ ✍️
                </div>
            </main>
        );
    }

    return (
        <main>
            <div className="article-list">
                {articles.map((article) => (
                    <ArticleCard
                        key={article.id}
                        id={article.id}
                        title={article.title}
                        author={article.author}
                        date={article.date}
                        summary={article.summary}
                        coverImage={article.cover_image}
                    />
                ))}
            </div>
        </main>
    );
};

export default HomePage;